/* eslint-disable no-unused-vars */
import * as S from './ChooseApps.styled';
import { Loader } from 'components';
import { useEffect } from 'react';
import GroupComponent from './components/GroupComponent';
import ItemComponent from './components/ItemComponent';

export const ChooseAppsContent = ({
  appsGroups,
  search,
  toggleOpenedGroup,
  isGroupOpened,
  toggleAppsGroup,
  isGroupChecked,
  isAppSelected,
  toggleSelectedApps,
  filteredFaundedApps,
  faundedAppsIsFatching,
  faundedAppsIsSuccess,
  appsSelectedData$,
}) => {
  useEffect(() => {
    if (filteredFaundedApps?.length > 0 && !isGroupOpened('all_groups')) {
      toggleOpenedGroup('all_groups');
    }
  }, [filteredFaundedApps]);

  if (search && !filteredFaundedApps?.length && !appsGroups?.length && faundedAppsIsSuccess) {
    return <S.NoResultMessage>No result</S.NoResultMessage>;
  }
  return (
    <>
      {appsGroups?.map(({ groupName, ...groupData }) => (
        <GroupComponent
          key={groupName}
          groupName={groupName}
          toggleOpenedGroup={toggleOpenedGroup}
          isGroupOpened={isGroupOpened}
          isGroupChecked={isGroupChecked}
          groupData={groupData}
          toggleAppsGroup={toggleAppsGroup}
          search={search}
        >
          {isGroupOpened(groupName) &&
            groupData.apps.map((app) => (
              <ItemComponent
                key={app.pba_number}
                app={app}
                isAppSelected={isAppSelected}
                toggleSelectedApps={toggleSelectedApps}
                search={search}
                appsSelectedData$={appsSelectedData$}
              />
            ))}
        </GroupComponent>
      ))}
      {faundedAppsIsFatching && <Loader.Local delay={100} />}
      {!faundedAppsIsFatching && filteredFaundedApps?.length > 0 && (
        <GroupComponent
          key='all_groups'
          groupName='all_groups'
          toggleOpenedGroup={toggleOpenedGroup}
          isGroupOpened={isGroupOpened}
          isGroupChecked={isGroupChecked}
          groupData={filteredFaundedApps}
          toggleAppsGroup={toggleAppsGroup}
          search={search}
        >
          {isGroupOpened('all_groups') &&
            filteredFaundedApps?.map((app) => (
              <ItemComponent
                key={app.pba_number}
                app={app}
                isAppSelected={isAppSelected}
                toggleSelectedApps={toggleSelectedApps}
                search={search}
                appsSelectedData$={appsSelectedData$}
              />
            ))}
        </GroupComponent>
      )}
    </>
  );
};
